export const MOTIVATION_REF = 'engagement-motivation-love-job'
export const RECOMMENDATION_REF = 'more-productive-recommendation'
export const POSITIVE_FEEDBACK_REF = 'Others-Admire'
export const NEGATIVE_FEEDBACK_REF = 'Others-Recommend-To-Change'
export const PORTAL_SUB_NAVIGATION = 'sub-navigation-portal'
export const PORTAL_SUB_NAVIGATION_MOBILE = 'sub-navigation-portal-mobile'
export const LAYOUT_IS_MOBILE = 1280
